<template>
    <span class="material-icons-round">{{field}}</span>
</template>

<script>
export default {
    props:{
        row:Object,
        field:[Object,String,Array,Number]
    }
}
</script>

<style>

</style>